import $ from 'jquery';

export default function headerSection() {
	$(function () {
		const mail = $('.mailchimp');

		if (mail.length) {
			const mailForm = mail.find('#mc-embedded-subscribe-form');
			const button = mail.find('.border_content-btn > .button');

			mail.on('submit', function (e) {
				e.preventDefault();
				let formData = mail.serialize();
				let error = $('#mce-error-response');
				let success = $('#mce-success-response');
				// $.post(mailForm.attr('action'), formData).done(function (data) {
				// 	console.log(data);
				// });
				error.css('display', 'none');
				success.css('display', 'none');

				$.ajax({
					type: mailForm.attr('method'),
					url: mailForm.attr('action'),
					data: mailForm.serialize(),
					cache: false,
					dataType: 'json',
					contentType: "application/json; charset=utf-8",
					error: function (err) {
						alert("Could not connect to the registration server. Please try again later.");
					},
					success: function (data) {
						if (data.result !== "success") {
							error.html(data.msg);
							error.css('display', 'block');
						} else {
							success.css('display', 'flex');

							if ($('.programMailchimp').length) {
								window.location.href = $('.continue a').attr('href');
							}
						}
					}
				})
			});

			button.click(function () {
				mailForm.submit();
			});
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/mailchimp.js